import { env } from '@/config/env'

/** Where the API lives. Set `VITE_API_BASE_URL` (see `.env.example`); in development `VITE_API_USE_PROXY=true` sends calls through the Vite proxy so the browser needs no CORS setup. */
let testBaseUrl: string | null = null

export const apiConfig = {
  /** Read at call time, not import time, so tests can point it somewhere else. */
  baseUrl(): string {
    if (testBaseUrl !== null) return testBaseUrl
    return import.meta.env.DEV && env.apiUseProxy ? '' : env.apiBaseUrl
  },
  timeoutMs: env.apiTimeoutMs,
}

/** Tests only: point every call at a fake server (`''` for same-origin). Pass `null` to go back to the environment. */
export function setApiBaseUrlForTests(base: string | null) {
  testBaseUrl = base
}
